// Smooth scrolling, via the Lenis global loaded from the CDN in Webflow.
import { onReady } from '../utils/ready.js';

export function initLenis() {
  onReady(function () {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (!window.Lenis) return;
    new Lenis({ autoRaf: true });
  });
}
